var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneIcon = function SvgPhoneIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 1.65,
    d: "m5.47 7.74.718-.527-.862-5.485c-1.265-.431-2.373-.258-3.324.521C.575 3.42.695 6.781 1.082 8.385c.389 1.603 1.409 3.61 3.645 6.017 2.236 2.407 6.989 4.59 9.936 4.357 2.023-.357 2.894-1.959 2.612-4.805l-5.182-1.068-.613.799a.768.768 0 0 1-.955.218c-1.45-.732-2.49-1.408-3.124-2.03-.632-.62-1.349-1.67-2.15-3.148a.768.768 0 0 1 .22-.984Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PhoneIcon.26df04cc71bf2d7e3633586e303f4f61.svg";